import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";
import PageHeader from "./Header";

const ResourceContainer = styled.div`
  background-color: #f7f9fc;
  min-height: 100vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ResourceHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  h1 {
    font-size: 2.5rem;
    color: #1a202c;
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 1.2rem;
    color: #4a5568;
    max-width: 600px;
    margin: 0 auto;
  }
`;

const ResourceCard = styled.div`
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  margin: 1rem;
  width: 300px;
  height: 400px;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }

  img {
    width: 100%;
    height: 140px; 
    object-fit: cover;
    border-bottom: 1px solid #e2e8f0;
  }

  div {
    flex: 1;
    padding: 1rem;
    display: flex;
    flex-direction: column;

    h2 {
      font-size: 1.25rem;
      color: #2d3748;
      margin-bottom: 0.2rem;
    }

    p {
      font-size: 1rem;
      color: #718096;
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;

  a {
    text-decoration: none;
    padding: 0.5rem 1.5rem;
    border-radius: 8px;
    font-weight: bold;
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .read {
    background-color: #3182ce;
    color: white;
    &:hover {
      background-color: #2b6cb0;
    }
  }

  .download {
    background-color: #edf2f7;
    color: #2d3748;
    border: 1px solid #cbd5e0;
    &:hover {
      background-color: #e2e8f0;
    }
  }
`;

function ResourcePage() {
  const [resources, setResources] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init();

    const fetchResources = async () => {
      try {
        const response = await fetch(
          "https://pristineacademicconsultancy.com/Admin/fetch_resource.php"
        );
        if (!response.ok) throw new Error("Failed to fetch resources");
        const data = await response.json();
        setResources(data);
      } catch (error) {
        console.error("Error fetching resources:", error);
        setError("Failed to load resources. Please try again later.");
      }
    };

    fetchResources();
  }, []);

  return (
    <>
      <PageHeader
        title="Explore Our Resources"
        subtitle="E Hub"
        description="Discover a variety of insightful guides, articles, and downloadable resources to enhance your skills."
        buttonText="Get Started"
        buttonAction={() => alert("Button clicked!")}
        backgroundImage="images/education.jpg"
      />

      <ResourceContainer>
        <ResourceHeader>
          <h1>Available Resources</h1>
          <p>Browse through our curated selection of academic and research materials.</p>
        </ResourceHeader>
        {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
        <div
          className="resource-list"
          style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
        >
          {resources.map((resource) => (
            <ResourceCard key={resource.id} data-aos="fade-up">
              <img
                src={resource.image_path && resource.image_path.trim() !== "" ? resource.image_path : "images/about.jpeg"}
                alt={resource.title}
              />
              <div>
                <h2>{resource.title}</h2>
                <p>{resource.description}</p>
                <ButtonGroup>
                  <a
                    href={resource.file_path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="read"
                  >
                    Read More
                  </a>
                  <a href={resource.file_path} download className="download">
                    Download
                  </a>
                </ButtonGroup>
              </div>
            </ResourceCard>
          ))}
        </div>
      </ResourceContainer>
    </>
  );
}

export default ResourcePage;
